import {
    useEffect
} from "react";
import {
    useSelector
} from "react-redux";

/* Runs callback on load and when auth changes */

const useAuthEffect = (callback, params = []) => {
    const isAuth = useSelector(state => state.session.isAuth);

    useEffect(() => {
        callback(isAuth);
    }, [isAuth, ...params]);
}

export default useAuthEffect;